import { useTemplateQuery } from '@orgnc/core/hooks';
import { IArticle } from '@orgnc/core/lib/wordpress/api/adapters/articleAdapter';
import { IMediaFragment } from '@orgnc/core/generated/graphql-operations';
import postExtraFieldsQuery from '../lib/queries/postExtraFieldsQuery';

export type PostExtraFields = {
  hideableFeaturedImageEnabled: boolean;
  featuredImage?: IMediaFragment;
  contactInformation: {
    faxNumber: string;
    email: string;
    telephoneNumber: string;
    websiteUrl: string;
    informationRequestUrl: string;
  };
};

const usePostExtraFields = (post: IArticle): PostExtraFields => {
  const { data } = useTemplateQuery(postExtraFieldsQuery, post);

  return {
    hideableFeaturedImageEnabled:
      data?.acfOptionsGeneral?.generalOptions?.aimPosts
        ?.enableHideableFeaturedImage ?? false,
    featuredImage:
      data?.post?.aimFeaturedImage?.hideableFeaturedImage ?? undefined,
    contactInformation: {
      faxNumber: data?.post?.contactInformation?.faxNumber || '',
      telephoneNumber: data?.post?.contactInformation?.telephoneNumber || '',
      email: data?.post?.contactInformation?.email || '',
      websiteUrl: data?.post?.contactInformation?.websiteUrl || '',
      informationRequestUrl:
        data?.post?.contactInformation?.informationRequestUrl || '',
    },
  };
};

export default usePostExtraFields;
